import Decimal from "decimal.js";

/**
 * Preço no formato brasileiro: "R$ 1.234,56".
 *
 * `customSeparator` troca o separador decimal (a vírgula). Com ponto como
 * decimal não há separador de milhar, que ficaria ambíguo.
 */
export default function toPriceDisplay(amount, customSeparator = null) {
  const decimalSeparator = customSeparator || ",";
  const value = Decimal(amount);
  const [integer, cents] = value.abs().toFixed(2).split(".");
  const sign = value.isNegative() && !value.isZero() ? "-" : "";
  const grouped =
    decimalSeparator === "."
      ? integer
      : integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `R$ ${sign}${grouped}${decimalSeparator}${cents}`;
}
